import { observer } from 'mobx-react-lite';

import { IcPreviewIcon } from '@gem/icons';
import { useTranslation } from '@gem/modules/i18n';
import { IconView, SwitchMenuItem } from '@gem/ui-kit';

import { useSpaceVisibilityPresenter } from './SpaceVisibility.presenter';

export const SpaceVisibility = observer(({ className, titleClassName, group }) => {
  const presenter = useSpaceVisibilityPresenter({ group });
  const { t } = useTranslation();

  if (!presenter.isShow) {
    return null;
  }

  return (
    <SwitchMenuItem
      className={className}
      titleClassName={titleClassName}
      title={t('space_visibility_visible')}
      isChecked={presenter.isVisible}
      icon={<IconView Icon={IcPreviewIcon} />}
      onChange={presenter.onToggle}
    />
  );
});
